module.exports = __webpack_public_path__ + "img/tcys.c2c0cd41.png";